module.exports = "/static/media/add_icon.ca22bb26.svg";